







import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class CompletedDefaultCaption extends Vue {
  @Prop({ required: true })
  hostName: string
}
